import { render } from "./SimpleTableTextPartners.vue?vue&type=template&id=324b0112&scoped=true"
import script from "./SimpleTableTextPartners.vue?vue&type=script&lang=js"
export * from "./SimpleTableTextPartners.vue?vue&type=script&lang=js"

import "./SimpleTableTextPartners.vue?vue&type=style&index=0&id=324b0112&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324b0112"]])

export default __exports__